function StaticFooter() {
  const year = new Date().getFullYear();

  /* eslint-disable lingui/no-unlocalized-strings -- static marketing page, intentionally untranslated */
  return (
    <footer className="static-footer">
      <div className="static-content-container">
        <nav>
          <a href="/iphone">iPhone &amp; iPad</a>
          <a href="/android">Android</a>
          <a href="/premium">Premium</a>
          <a href="/help">Help</a>
          <a href="/developers">Developers</a>
          <a href="http://blog.instapaper.com" target="_blank" rel="noopener noreferrer">
            Blog
          </a>
          <a
            href="http://twitter.com/Instapaper"
            target="_blank"
            rel="noopener noreferrer"
          >
            Twitter
          </a>
          <a
            href="https://www.facebook.com/instapaperholdings"
            target="_blank"
            rel="noopener noreferrer"
          >
            Facebook
          </a>
        </nav>
        <div className="static-footer-copyright">© {year} Instant Paper, Inc.</div>
      </div>
    </footer>
  );
}

export default StaticFooter;
